/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Geolocation } from '@capacitor/geolocation';
import { AlertController, ViewDidEnter, ViewWillEnter } from '@ionic/angular';
import { MenuCategory, MenuItem } from 'src/app/models/rich-data.model';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { DataService } from 'src/app/services/data.service';
import { GetTranslationService } from 'src/app/services/get-translation.service';
import { GoogleMap } from '@angular/google-maps';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent implements OnInit, ViewDidEnter, OnDestroy, ViewWillEnter {

  center: google.maps.LatLngLiteral = {lat: +this.dataServ.rData.lat_lng.split(',')[0], lng: +this.dataServ.rData.lat_lng.split(',')[1]};
  showMap = false;

  annots: any[] = [];
  locations: {
    location: any;
    title: string;
    subtitle: string;
    item: MenuItem;
  }[] = [];

  loaded = false;

  marker: google.maps.LatLngLiteral[] = [{lat: 0, lng: 0}];
  icon: any = {
    url: 'assets/svg/pin.svg',
    scaledSize: {
      width: 75,
      height: 75
    }
  };


  constructor(
    public dataServ: DataService,
    private caption: CaptionPipe,
    private alerctrl: AlertController,
    private translate: GetTranslationService,
    private router: Router,
    private titleService: Title
  ) { }

  async ngOnInit() {

    if (!this.dataServ.rData) {
      await this.dataServ.getRichData();
      await this.dataServ.removeDateRange(this.dataServ.baseData);
    }

    for (const KEY in this.dataServ.rData) {
      if (this.dataServ.rData[KEY] && this.dataServ.rData[KEY].show && this.dataServ.rData[KEY].menu_categories) {
        (this.dataServ.rData[KEY].menu_categories as MenuCategory[]).forEach(category => {
          if (category.menu_items) {
            category.menu_items.forEach(item => {
              if (item.activate_map_location) {
                if (item.map_location) {
                  this.locations.push({
                    location: [+item.map_location.split(',')[0], +item.map_location.split(',')[1]],
                    title: this.caption.transform(item.name),
                    subtitle: this.caption.transform(item.location_description),
                    item
                  });
                }
              }
            });
          }
        });
      }
    }

    this.loaded = true;
  }

  ionViewWillEnter(): void {
    this.titleService.setTitle('Map');
  }

  ngOnDestroy() {
    try {
      Geolocation.clearWatch({ id: 'watch' });
    } catch { }
  }

  async ionViewDidEnter() {

    const STATUS = await Geolocation.checkPermissions();
    if (STATUS.location !== 'granted') {
      Geolocation.requestPermissions();
    }

    const ISGRANTED = await Geolocation.checkPermissions();

    if (ISGRANTED.location === 'granted') {
      Geolocation.watchPosition({}, data => {
        this.marker = [{lat: data.coords.latitude, lng: data.coords.longitude}];
      });
    }
  }

  async open(item: MenuItem) {
    const DETAIL = await this.translate.getTranslate('Detail');
    const CLOSE = await this.translate.getTranslate('Close');
    let header = this.caption.transform(item.name);
    const TEXT = this.caption.transform(item.location_description);

    if (!header) {
      header = this.caption.transform(item.name, 'tr');
    }

    const ALERT = await this.alerctrl.create({
      header,
      message: TEXT,
      buttons: [
        {
          text: CLOSE,
          handler: () => {
            ALERT.dismiss();
          }
        },
        {
          text: DETAIL,
          handler: () => {
            this.router.navigateByUrl(`/home/${item.menu_section_id}/${item.id}`);
          }
        }
      ]
    });

    await ALERT.present();
  }

}
